import Button from "@/common/elements/Button";
import Table from "@/common/elements/Table";
import { StyledFlex } from "@/common/styles";

// Aliases are not present in the irisSearch API response.
// The table is kept ready for a future aliases endpoint; data is passed through
// so the parent can supply rows if available.
const Aliases = ({ data }) => {
  const rows = data?.aliases ?? [];

  return (
    <>
      <StyledFlex justify="end" style={{ marginBottom: "6px" }}>
        {/* <Button>Add Alias</Button> */}
        <Button style={{ marginLeft: "10px" }} disabled>Details</Button>
        {/* <Button style={{ marginLeft: "10px" }}>Delete</Button> */}
      </StyledFlex>

      <Table
        headers={[
          { key: "lName",             text: "LName"              },
          { key: "fName",             text: "FName"              },
          { key: "mName",             text: "MName"              },
          { key: "dob",               text: "Date of Birth"      },
          { key: "ssn",               text: "SSN"                },
          { key: "suffix",            text: "Suffix"             },
          { key: "questionedIdentity",text: "Questioned Identity"},
        ]}
        data={rows}
        noDataMessage="No aliases found."
      />
    </>
  );
};

export default Aliases;
